export default [
  {
    name: 'Pixel Shooter',
    url: 'https://ctjs.rocks/demo/',
    cover: 'https://ctjs.rocks/img/logo.svg',
    desc: 'ct.js 制作的射击小游戏'

  },
  {
    name: 'Pixel Shooter',
    url: 'https://ctjs.rocks/demo/',
    cover: 'https://ctjs.rocks/img/logo.svg',
    desc: 'ct.js 制作的射击小游戏'
  },
  {
    name: 'A Dark Room',
    url: 'https://adarkroom.doublespeakgames.com/',
    cover: 'https://raw.githubusercontent.com/doublespeakgames/adarkroom/master/assets/favicon.ico',
    desc: '文字探索冒险游戏'
  },
  {
    name: 'Chess AI',
    url: 'https://chessmasterjs.com/',
    cover: 'https://upload.wikimedia.org/wikipedia/commons/3/33/Chess_board_opening_staunton.jpg',
    desc: '和 AI 下国际象棋'
  },
  {
    name: 'Particle Clicker',
    url: 'https://particle-clicker.web.cern.ch/',
    cover: 'https://particle-clicker.web.cern.ch/img/particle-clicker.png',
    desc: 'CERN 出品的科学类点击游戏'
  },
  {
    name: 'Astray',
    url: 'https://tylerglaiel.com/Astray/',
    cover: 'https://tylerglaiel.com/Astray/assets/astray.png',
    desc: '第一人称迷宫解谜游戏'
  },
  {
    name: 'The Wizard',
    url: 'https://steve.sunydev.com/wizard/',
    cover: 'https://steve.sunydev.com/wizard/icon.png',
    desc: '回合制策略小游戏'
  },
  {
    name: 'Torus',
    url: 'https://wwwtyro.net/space-3d/',
    cover: 'https://raw.githubusercontent.com/wwwtyro/space-3d/master/img/thumb.jpg',
    desc: '3D 太空射击小游戏'
  },
  {
    name: 'Cube 3D',
    url: 'https://al-ro.github.io/projects/CubeRunner/',
    cover: 'https://al-ro.github.io/projects/CubeRunner/thumbnail.png',
    desc: '3D 方块奔跑躲避类游戏'
  },
  {
    name: 'Platformer',
    url: 'https://sanderfrenken.github.io/plaform-html5-game/',
    cover: 'https://sanderfrenken.github.io/plaform-html5-game/img/icon.png',
    desc: '基础平台跳跃类游戏'
  }
]
